import React from "react";
import { Button, Dialog, Grid } from "@mui/material";
import nanoId from "nano-id";

import SBFileUploader from "../shared/SBFileUploader";

/**
 * AddAlertImages - Component for adding images to global alerts.
 * @param {object} props - The props object.
 * @param {boolean} props.open - Indicates whether the dialog is open
 * @param {Function} props.close - Function to close the dialog
 * @param {object} props.alert - The alert object
 * @param {Function} props.setAlert - Function to update the alert.
 *
 * @returns {React.Component} The AddAlertImages component.
 */
export default function AddAlertImages({ open, close, alert, setAlert }) {
  // Handles the submission of the uploaded file and updates the alert with the new image.
  const handleSubmit = (data, fileUrl) => {
    setAlert({
      ...alert,
      image: fileUrl,
    });
  };

  // Closes the image dialog.
  const handleClose = () => {
    // setFile(null);
    // setFileName(null);
    close();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <Grid container padding={2} spacing={1}>
          <Grid item xs={12}>
            <SBFileUploader
              bucketName="alert_images"
              folderName={nanoId()}
              info={handleSubmit}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handleClose}
            >
              {alert.image ? "Done" : "Cancel"}
            </Button>{" "}
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
